function executorEventsPayment() {
  const completeRegistrationButton = document.getElementById(
    'complete-registration-button'
  );
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(async function (mutation) {
      if (mutation.target.classList.contains('is-open')) {
        getTemporaryRegistrationSummary();
        completeRegistrationButton.addEventListener('click', function () {
          completeExecutorEventRegistration();
        });
      }
    });
  });

  observer.observe(document.querySelector('#modal-pay'), {
    attributes: true,
    attributeFilter: ['class'],
  });
}

function getTemporaryRegistrationSummary() {
  const temporaryRegistrationId = document.getElementById(
    'temporary-registration-id'
  ).dataset.temporaryRegistrationId;

  $.ajax({
    type: 'POST',
    url: '/api/executor/get-temporary-summary',
    data: {
      temporaryRegistrationId: temporaryRegistrationId,
    },
    success: function (data) {
      renderSummary(data);
    },
  });
}

function renderSummary(data) {
  const totalWithoutVatDiv = document.getElementById(
    'total-without-vat-payment'
  );
  const vatDiv = document.getElementById('total-vat-payment');
  const totalWithVatDiv = document.getElementById('total-with-vat-payment');
  const summaryRegisterDiv = document.getElementById(
    'summary-register-payment'
  );

  summaryRegisterDiv.innerHTML = '';
  summaryRegisterDiv.innerHTML =
    '<div class="summary__desc">Účasníků</div>' +
    '<div>' +
    data['participants'].count +
    '</div>' +
    '<div><strong>' +
    formatNumber(data['participants'].price) +
    ' Kč</strong></div>';

  Object.entries(data['resolvedAdditionals']).forEach(function (additional) {
    summaryRegisterDiv.innerHTML =
      summaryRegisterDiv.innerHTML +
      '<div class="summary__desc">' +
      additional[1].name +
      '</div>' +
      '                        <div>' +
      additional[1].count +
      '</div>' +
      '                        <div><strong>' +
      formatNumber(additional[1].price) +
      ' Kč</strong></div>';
  });

  totalWithoutVatDiv.innerHTML =
    formatNumber(data['totalPriceWithoutVat'].toFixed(2)) + ' Kč';
  totalWithVatDiv.innerHTML =
    formatNumber(data['totalPriceWithVat'].toFixed(2)) + ' Kč';
  vatDiv.innerHTML = formatNumber(data['totalVat'].toFixed(2)) + ' Kč';
}

function completeExecutorEventRegistration() {
  const temporaryRegistrationId = document.getElementById(
    'temporary-registration-id'
  ).dataset.temporaryRegistrationId;

  var url = document.location.href.split('#')[0];

  $.ajax({
    type: 'POST',
    url: '/api/executor/complete-registration',
    data: {
      temporaryRegistrationId: temporaryRegistrationId,
    },
    success: function () {
      window.location.href = url;
    },
  });
}
